// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pm-dashboard-page {
  padding: 1.5rem 1.75rem;
}

.pm-dashboard-page .page-header {
  margin-bottom: 1.25rem;
}

.pm-dashboard-page .card {
  border-color: #e7edf3;
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.04);
}

.pm-dashboard-page .card-header {
  min-height: 56px;
}

.pm-dash-section-subtitle {
  font-size: 0.8125rem;
  margin-top: 0.15rem;
}

.pm-dash-section-header {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: space-between;
}

.pm-dash-section-header-extra {
  flex-shrink: 0;
}

.pm-dash-workload-controls {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.pm-dash-month-picker {
  min-width: 150px;
  width: auto;
}

.pm-dash-helper-text {
  font-size: 0.8125rem;
}

.pm-dash-error-banner {
  border-left: 4px solid #f76707;
  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.04);
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
}

/* ── KPI cards ─────────────────────────────────────────────────────────── */

.pm-dash-kpi-card {
  border-top: 3px solid var(--pm-dash-kpi-color);
}

.pm-dash-kpi-icon {
  align-items: center;
  background: var(--pm-dash-kpi-bg);
  border-radius: 8px;
  color: var(--pm-dash-kpi-color);
  display: inline-flex;
  flex-shrink: 0;
  height: 46px;
  justify-content: center;
  width: 46px;
}

.pm-dash-kpi-label {
  font-size: 0.73rem;
}

.pm-dash-kpi-value {
  color: var(--pm-dash-kpi-color);
  font-size: 1.35rem;
  line-height: 1;
}

.pm-dash-kpi-primary { --pm-dash-kpi-bg: rgba(31, 143, 152, 0.12); --pm-dash-kpi-color: #1f8f98; }
.pm-dash-kpi-success { --pm-dash-kpi-bg: rgba(0, 166, 121, 0.12); --pm-dash-kpi-color: #00a679; }
.pm-dash-kpi-warning { --pm-dash-kpi-bg: rgba(245, 159, 0, 0.14); --pm-dash-kpi-color: #c87b00; }
.pm-dash-kpi-danger { --pm-dash-kpi-bg: rgba(214, 57, 57, 0.12); --pm-dash-kpi-color: #d63939; }
.pm-dash-kpi-info { --pm-dash-kpi-bg: rgba(22, 114, 185, 0.12); --pm-dash-kpi-color: #1672b9; }
.pm-dash-kpi-purple { --pm-dash-kpi-bg: rgba(111, 66, 193, 0.12); --pm-dash-kpi-color: #6f42c1; }
.pm-dash-kpi-teal { --pm-dash-kpi-bg: rgba(15, 118, 110, 0.12); --pm-dash-kpi-color: #0f766e; }
.pm-dash-kpi-orange { --pm-dash-kpi-bg: rgba(247, 103, 7, 0.12); --pm-dash-kpi-color: #f76707; }

/* ── Stage / Health distribution ──────────────────────────────────────── */

.pm-dash-distribution {
  display: grid;
  gap: 0.65rem;
}

.pm-dash-distribution-row {
  align-items: center;
  display: grid;
  gap: 0.65rem;
  grid-template-columns: 120px 1fr 32px;
}

.pm-dash-distribution-label .badge {
  font-size: 0.75rem;
  min-width: 96px;
}

.pm-dash-distribution-bar {
  height: 8px;
}

.pm-dash-distribution-count {
  font-size: 0.85rem;
  font-weight: 600;
  text-align: right;
}

/* ── Portfolio progress ────────────────────────────────────────────────── */

.pm-dash-progress-bar {
  height: 8px;
  margin-top: 0.35rem;
}

.pm-dash-inline-progress {
  height: 6px;
  min-width: 72px;
  width: 90px;
}

.pm-dash-stat-tile {
  background: #f8fafc;
  border: 1px solid #e7edf3;
  border-radius: 8px;
  height: 100%;
  padding: 0.85rem 1rem;
}

.pm-dash-stat-value {
  font-size: 1.5rem;
  line-height: 1.15;
  margin-top: 0.2rem;
}

/* ── Tables ────────────────────────────────────────────────────────────── */

.pm-dash-table th {
  color: #667085;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.pm-dash-table td {
  vertical-align: middle;
}

.pm-dash-timer {
  align-items: center;
  color: #1f8f98;
  display: inline-flex;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

/* ── Activity feed ─────────────────────────────────────────────────────── */

.pm-dash-activity-list {
  display: grid;
  gap: 0.85rem;
  list-style: none;
  margin: 0;
  max-height: 360px;
  overflow-y: auto;
  padding: 0;
}

.pm-dash-activity-item {
  display: flex;
  gap: 0.65rem;
}

.pm-dash-activity-dot {
  background: #1f8f98;
  border-radius: 999px;
  flex-shrink: 0;
  height: 8px;
  margin-top: 0.35rem;
  width: 8px;
}

.pm-dash-activity-description {
  font-size: 0.875rem;
  line-height: 1.4;
}

/* ── Loading / empty states ────────────────────────────────────────────── */

.pm-dash-panel-loading,
.pm-dash-empty-state {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 140px;
  text-align: center;
}

@keyframes pm-dash-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.pm-dash-spin {
  animation: pm-dash-spin 1s linear infinite;
}

/* ── Clickable monitoring elements ────────────────────────────────────── */
/* Shared by KPI cards, Stage/Health distribution rows, table rows (Attention
   Needed, Upcoming Deadlines), and Recent Activity items — kept intentionally subtle (background tint /
   small shadow only) so the dashboard stays executive-friendly, and never
   shifts layout (no width/height/margin change on hover). */

.pm-dash-kpi-card.pm-dash-clickable {
  cursor: pointer;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.pm-dash-kpi-card.pm-dash-clickable:hover {
  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.09);
}

.pm-dash-kpi-card.pm-dash-clickable:focus-visible {
  outline: 2px solid #1f8f98;
  outline-offset: 2px;
}

.pm-dash-distribution-row.pm-dash-clickable {
  border-radius: 6px;
  cursor: pointer;
  margin: -0.15rem -0.4rem;
  padding: 0.15rem 0.4rem;
  transition: background-color 0.15s ease;
}

.pm-dash-distribution-row.pm-dash-clickable:hover {
  background-color: rgba(31, 143, 152, 0.07);
}

.pm-dash-distribution-row.pm-dash-clickable:focus-visible {
  outline: 2px solid #1f8f98;
  outline-offset: -2px;
}

.pm-dash-clickable-row {
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.pm-dash-clickable-row:hover {
  background-color: rgba(31, 143, 152, 0.06);
}

.pm-dash-clickable-row:focus-visible {
  outline: 2px solid #1f8f98;
  outline-offset: -2px;
}

.pm-dash-activity-item.pm-dash-clickable {
  border-radius: 6px;
  cursor: pointer;
  margin: -0.35rem -0.4rem;
  padding: 0.35rem 0.4rem;
  transition: background-color 0.15s ease;
}

.pm-dash-activity-item.pm-dash-clickable:hover {
  background-color: rgba(31, 143, 152, 0.07);
}

.pm-dash-activity-item.pm-dash-clickable:focus-visible {
  outline: 2px solid #1f8f98;
  outline-offset: -2px;
}

@media (max-width: 991.98px) {
  .pm-dashboard-page {
    padding: 1rem;
  }

  .pm-dashboard-page .page-header .row {
    row-gap: 1rem;
  }

  .pm-dashboard-page .page-header .col-auto {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .pm-dashboard-page .btn-list {
    justify-content: flex-start;
  }

  .pm-dash-kpi-icon {
    height: 40px;
    width: 40px;
  }

  .pm-dash-kpi-value {
    font-size: 1.25rem;
  }

  .pm-dash-distribution-row {
    grid-template-columns: 100px 1fr 28px;
  }

  .pm-dashboard-page .table {
    width: 920px;
  }

  .pm-dashboard-page .table-responsive {
    overflow-x: auto;
    scrollbar-gutter: stable;
  }
}

@media (max-width: 767.98px) {
  .pm-dashboard-page {
    padding: 1rem;
  }

  .pm-dashboard-page .btn-list {
    width: 100%;
  }

  .pm-dashboard-page .btn-list .btn {
    justify-content: center;
    width: 100%;
  }

  .pm-dash-distribution-row {
    grid-template-columns: 1fr;
    gap: 0.35rem;
  }

  .pm-dash-distribution-count {
    text-align: left;
  }

  .pm-dash-section-header-extra {
    width: 100%;
  }

  .pm-dash-workload-controls {
    justify-content: flex-start;
    width: 100%;
  }

  .pm-dash-workload-controls .btn-group {
    width: 100%;
  }

  .pm-dash-workload-controls .btn-group .btn {
    flex: 1 1 auto;
  }

  .pm-dash-month-picker {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PmDashboard/PmDashboard.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;EAC7C,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,6EAA6E;;AAE7E;EACE,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uBAAuB,0CAA0C,EAAE,4BAA4B,EAAE;AACjG,uBAAuB,yCAAyC,EAAE,4BAA4B,EAAE;AAChG,uBAAuB,yCAAyC,EAAE,4BAA4B,EAAE;AAChG,sBAAsB,yCAAyC,EAAE,4BAA4B,EAAE;AAC/F,oBAAoB,0CAA0C,EAAE,4BAA4B,EAAE;AAC9F,sBAAsB,0CAA0C,EAAE,4BAA4B,EAAE;AAChG,oBAAoB,0CAA0C,EAAE,4BAA4B,EAAE;AAC9F,sBAAsB,yCAAyC,EAAE,4BAA4B,EAAE;;AAE/F,4EAA4E;;AAE5E;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6EAA6E;;AAE7E;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,6EAA6E;;AAE7E;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6EAA6E;;AAE7E;;EAEE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,4EAA4E;AAC5E;;;4DAG4D;;AAE5D;EACE,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".pm-dashboard-page {\n  padding: 1.5rem 1.75rem;\n}\n\n.pm-dashboard-page .page-header {\n  margin-bottom: 1.25rem;\n}\n\n.pm-dashboard-page .card {\n  border-color: #e7edf3;\n  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.04);\n}\n\n.pm-dashboard-page .card-header {\n  min-height: 56px;\n}\n\n.pm-dash-section-subtitle {\n  font-size: 0.8125rem;\n  margin-top: 0.15rem;\n}\n\n.pm-dash-section-header {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  justify-content: space-between;\n}\n\n.pm-dash-section-header-extra {\n  flex-shrink: 0;\n}\n\n.pm-dash-workload-controls {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n\n.pm-dash-month-picker {\n  min-width: 150px;\n  width: auto;\n}\n\n.pm-dash-helper-text {\n  font-size: 0.8125rem;\n}\n\n.pm-dash-error-banner {\n  border-left: 4px solid #f76707;\n  box-shadow: 0 6px 16px rgba(16, 24, 40, 0.04);\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n}\n\n/* ── KPI cards ─────────────────────────────────────────────────────────── */\n\n.pm-dash-kpi-card {\n  border-top: 3px solid var(--pm-dash-kpi-color);\n}\n\n.pm-dash-kpi-icon {\n  align-items: center;\n  background: var(--pm-dash-kpi-bg);\n  border-radius: 8px;\n  color: var(--pm-dash-kpi-color);\n  display: inline-flex;\n  flex-shrink: 0;\n  height: 46px;\n  justify-content: center;\n  width: 46px;\n}\n\n.pm-dash-kpi-label {\n  font-size: 0.73rem;\n}\n\n.pm-dash-kpi-value {\n  color: var(--pm-dash-kpi-color);\n  font-size: 1.35rem;\n  line-height: 1;\n}\n\n.pm-dash-kpi-primary { --pm-dash-kpi-bg: rgba(31, 143, 152, 0.12); --pm-dash-kpi-color: #1f8f98; }\n.pm-dash-kpi-success { --pm-dash-kpi-bg: rgba(0, 166, 121, 0.12); --pm-dash-kpi-color: #00a679; }\n.pm-dash-kpi-warning { --pm-dash-kpi-bg: rgba(245, 159, 0, 0.14); --pm-dash-kpi-color: #c87b00; }\n.pm-dash-kpi-danger { --pm-dash-kpi-bg: rgba(214, 57, 57, 0.12); --pm-dash-kpi-color: #d63939; }\n.pm-dash-kpi-info { --pm-dash-kpi-bg: rgba(22, 114, 185, 0.12); --pm-dash-kpi-color: #1672b9; }\n.pm-dash-kpi-purple { --pm-dash-kpi-bg: rgba(111, 66, 193, 0.12); --pm-dash-kpi-color: #6f42c1; }\n.pm-dash-kpi-teal { --pm-dash-kpi-bg: rgba(15, 118, 110, 0.12); --pm-dash-kpi-color: #0f766e; }\n.pm-dash-kpi-orange { --pm-dash-kpi-bg: rgba(247, 103, 7, 0.12); --pm-dash-kpi-color: #f76707; }\n\n/* ── Stage / Health distribution ──────────────────────────────────────── */\n\n.pm-dash-distribution {\n  display: grid;\n  gap: 0.65rem;\n}\n\n.pm-dash-distribution-row {\n  align-items: center;\n  display: grid;\n  gap: 0.65rem;\n  grid-template-columns: 120px 1fr 32px;\n}\n\n.pm-dash-distribution-label .badge {\n  font-size: 0.75rem;\n  min-width: 96px;\n}\n\n.pm-dash-distribution-bar {\n  height: 8px;\n}\n\n.pm-dash-distribution-count {\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-align: right;\n}\n\n/* ── Portfolio progress ────────────────────────────────────────────────── */\n\n.pm-dash-progress-bar {\n  height: 8px;\n  margin-top: 0.35rem;\n}\n\n.pm-dash-inline-progress {\n  height: 6px;\n  min-width: 72px;\n  width: 90px;\n}\n\n.pm-dash-stat-tile {\n  background: #f8fafc;\n  border: 1px solid #e7edf3;\n  border-radius: 8px;\n  height: 100%;\n  padding: 0.85rem 1rem;\n}\n\n.pm-dash-stat-value {\n  font-size: 1.5rem;\n  line-height: 1.15;\n  margin-top: 0.2rem;\n}\n\n/* ── Tables ────────────────────────────────────────────────────────────── */\n\n.pm-dash-table th {\n  color: #667085;\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n}\n\n.pm-dash-table td {\n  vertical-align: middle;\n}\n\n.pm-dash-timer {\n  align-items: center;\n  color: #1f8f98;\n  display: inline-flex;\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n}\n\n/* ── Activity feed ─────────────────────────────────────────────────────── */\n\n.pm-dash-activity-list {\n  display: grid;\n  gap: 0.85rem;\n  list-style: none;\n  margin: 0;\n  max-height: 360px;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.pm-dash-activity-item {\n  display: flex;\n  gap: 0.65rem;\n}\n\n.pm-dash-activity-dot {\n  background: #1f8f98;\n  border-radius: 999px;\n  flex-shrink: 0;\n  height: 8px;\n  margin-top: 0.35rem;\n  width: 8px;\n}\n\n.pm-dash-activity-description {\n  font-size: 0.875rem;\n  line-height: 1.4;\n}\n\n/* ── Loading / empty states ────────────────────────────────────────────── */\n\n.pm-dash-panel-loading,\n.pm-dash-empty-state {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 140px;\n  text-align: center;\n}\n\n@keyframes pm-dash-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.pm-dash-spin {\n  animation: pm-dash-spin 1s linear infinite;\n}\n\n/* ── Clickable monitoring elements ────────────────────────────────────── */\n/* Shared by KPI cards, Stage/Health distribution rows, table rows (Attention\n   Needed, Upcoming Deadlines), and Recent Activity items — kept intentionally subtle (background tint /\n   small shadow only) so the dashboard stays executive-friendly, and never\n   shifts layout (no width/height/margin change on hover). */\n\n.pm-dash-kpi-card.pm-dash-clickable {\n  cursor: pointer;\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.pm-dash-kpi-card.pm-dash-clickable:hover {\n  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.09);\n}\n\n.pm-dash-kpi-card.pm-dash-clickable:focus-visible {\n  outline: 2px solid #1f8f98;\n  outline-offset: 2px;\n}\n\n.pm-dash-distribution-row.pm-dash-clickable {\n  border-radius: 6px;\n  cursor: pointer;\n  margin: -0.15rem -0.4rem;\n  padding: 0.15rem 0.4rem;\n  transition: background-color 0.15s ease;\n}\n\n.pm-dash-distribution-row.pm-dash-clickable:hover {\n  background-color: rgba(31, 143, 152, 0.07);\n}\n\n.pm-dash-distribution-row.pm-dash-clickable:focus-visible {\n  outline: 2px solid #1f8f98;\n  outline-offset: -2px;\n}\n\n.pm-dash-clickable-row {\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.pm-dash-clickable-row:hover {\n  background-color: rgba(31, 143, 152, 0.06);\n}\n\n.pm-dash-clickable-row:focus-visible {\n  outline: 2px solid #1f8f98;\n  outline-offset: -2px;\n}\n\n.pm-dash-activity-item.pm-dash-clickable {\n  border-radius: 6px;\n  cursor: pointer;\n  margin: -0.35rem -0.4rem;\n  padding: 0.35rem 0.4rem;\n  transition: background-color 0.15s ease;\n}\n\n.pm-dash-activity-item.pm-dash-clickable:hover {\n  background-color: rgba(31, 143, 152, 0.07);\n}\n\n.pm-dash-activity-item.pm-dash-clickable:focus-visible {\n  outline: 2px solid #1f8f98;\n  outline-offset: -2px;\n}\n\n@media (max-width: 991.98px) {\n  .pm-dashboard-page {\n    padding: 1rem;\n  }\n\n  .pm-dashboard-page .page-header .row {\n    row-gap: 1rem;\n  }\n\n  .pm-dashboard-page .page-header .col-auto {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .pm-dashboard-page .btn-list {\n    justify-content: flex-start;\n  }\n\n  .pm-dash-kpi-icon {\n    height: 40px;\n    width: 40px;\n  }\n\n  .pm-dash-kpi-value {\n    font-size: 1.25rem;\n  }\n\n  .pm-dash-distribution-row {\n    grid-template-columns: 100px 1fr 28px;\n  }\n\n  .pm-dashboard-page .table {\n    width: 920px;\n  }\n\n  .pm-dashboard-page .table-responsive {\n    overflow-x: auto;\n    scrollbar-gutter: stable;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .pm-dashboard-page {\n    padding: 1rem;\n  }\n\n  .pm-dashboard-page .btn-list {\n    width: 100%;\n  }\n\n  .pm-dashboard-page .btn-list .btn {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .pm-dash-distribution-row {\n    grid-template-columns: 1fr;\n    gap: 0.35rem;\n  }\n\n  .pm-dash-distribution-count {\n    text-align: left;\n  }\n\n  .pm-dash-section-header-extra {\n    width: 100%;\n  }\n\n  .pm-dash-workload-controls {\n    justify-content: flex-start;\n    width: 100%;\n  }\n\n  .pm-dash-workload-controls .btn-group {\n    width: 100%;\n  }\n\n  .pm-dash-workload-controls .btn-group .btn {\n    flex: 1 1 auto;\n  }\n\n  .pm-dash-month-picker {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
